/**
 * SectionLabel — the system's one section-header pattern: a small-caps label
 * with a hairline rule. Optional trailing subtitle in muted text.
 */
export function SectionLabel({
  label,
  subtitle,
}: {
  label: string;
  subtitle?: string;
}) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <span className="text-2xs font-bold tracking-widest text-gray-400 uppercase whitespace-nowrap">
        {label}
      </span>
      {subtitle && (
        <span className="text-xs text-gray-400 truncate">{subtitle}</span>
      )}
      <div className="flex-1 h-px bg-gray-100" />
    </div>
  );
}
